import * as yup from 'yup'
import type { Database } from '../types/supabase'
import {
  nullableNumberValidator,
  nullableStringValidator,
  commonFields,
  type InputType,
  type UploadType,
  type EmptyInputType,
  type UploadWithNewReferenceType,
} from './common'
import { KNOWN_MATERIALS } from './constants'

export type OilContentInput = Omit<
  InputType<OilContentUpload>,
  'material_id'
> & { material?: string | null }

type EmptyOilContentInput = EmptyInputType<OilContentInput>

type OilContentTable = Database['public']['Tables']['oil_content']['Insert']

type OilContentUpload = UploadType<OilContentTable>

type OilContentPreUpload = UploadWithNewReferenceType<OilContentUpload>

export type OilContentTypes = {
  upload: OilContentUpload
  withNewReference: OilContentPreUpload
  input: OilContentInput
  emptyInput: EmptyOilContentInput
}

export const schema: yup.ObjectSchema<OilContentInput> = yup
  .object({
    ...commonFields,
    material: nullableStringValidator.oneOf(
      KNOWN_MATERIALS,
      `Material must be one of the known materials: ${KNOWN_MATERIALS.join(
        ', ',
      )}`,
    ),
    moisture_status: nullableStringValidator,
    cultivar: nullableStringValidator,
    notes: nullableStringValidator,
    oil_content: nullableNumberValidator,
  })
  .test(
    'reference-id-or-new-reference-exists',
    'Reference ID or new reference must be provided',
    function (value) {
      if (
        value.reference_id ??
        (value.new_reference_citation && value.new_reference_description)
      ) {
        return true
      }
      return false
    },
  )

export const transform = (
  data: Partial<OilContentInput>,
): Partial<OilContentPreUpload> => {
  const { material, ...rest } = data

  const material_id = material
    ? KNOWN_MATERIALS.findIndex((m) => m === material) + 1
    : null

  return {
    ...rest,
    material_id,
  }
}
